import { render, staticRenderFns } from "./CardDetailKunjungan.vue?vue&type=template&id=01d30ff4&scoped=true&"
import script from "./CardDetailKunjungan.vue?vue&type=script&lang=ts&"
export * from "./CardDetailKunjungan.vue?vue&type=script&lang=ts&"
import style0 from "./CardDetailKunjungan.vue?vue&type=style&index=0&id=01d30ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d30ff4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow,VTab,VTabItem,VTabs,VTabsSlider})
